//"Reporte Inmunohematologia",

import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { donationTypeExtraction } from '../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class BloodGroups extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getDonationsType = this.getDonationsType.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.getWorkSession = this.getWorkSession.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],
			extraction_type_id:"all",
			work_sessions_id:"",
			extraction_type:[],
			donation_type_id:"all",
			donations_type:[],
			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",
			convoke_places:[],
			convoke_places_id:"all",
			listado:[],
			change_check: false,
			columns:[
				{title:'Donador', width:'200px', visible:'block'},
				{title:'Fecha de Nacimiento', width:'100px', visible:'block'},
				{title:'No. Donador', width:'120px', visible:'block'},
				{title:'Apto', width:'80px', visible:'block'},
				{title:'Fecha Extracción', width:'200px', visible:'block'},
				{title:'No. Donación', width:'150px', visible:'block'},
				{title:'Sexo', width:'100px', visible:'block'},
				{title:'Tipo Donación', width:'150px', visible:'block'},
				{title:'Tipo Extracción', width:'150px', visible:'block'},
				{title:'Grupo Inicial', width:'150px', visible:'block'},	
			],
			filename:"Reporte Inmunohematologia",
			fraction_columns:"",
			search_type:"date",
			rhGroup:[],
			group:"all",
			rh:"all",
			count:"",
			extraction_type_name:"",
			donation_type_name:"",
			convoke_places_name:"",
			group_name:"",
			rh_name:"",
			show_options:false,
			date_hour:"",
			medical:"",
			phenotypes_total:"",
			option:"",
			work_sessions:[],
			total_aptos:0,
			total_noAptos:0,

		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	async componentDidMount(){
				this.getWorkSession();

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
				
		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getConvokePlace();

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_type: aux_resp
            });
        }

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})
		this.getDonationsType();

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		})
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})

		this.setTable();
	}

		getWorkSession(){ 		
			fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
				method: 'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						work_sessions: response
					});
					console.log("GWAS", this.state)
				}
			});
		}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);
		
		var targets = [];
		this.state.columns.map((c, i)=>{
			if(i > 2 && i < this.state.columns.length - 1){
				targets.push(i);
			}
		});

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
					customize: (xlsx) => {
						var sheet = xlsx.xl.worksheets['sheet1.xml'];
						
						// Agregar información de filtros en las primeras filas
						var filterInfo = '';
						if(this.state.search_type === 'date'){
							filterInfo += 'Información Del: ' + moment(this.state.start_date).format("DD/MM/YYYY") + ' Al: ' + moment(this.state.end_date).format("DD/MM/YYYY") + '\n';
						}
						
						if(this.state.convoke_places_id !== "all" && this.state.convoke_places_id !== ""){
							filterInfo += 'Lugar de Colecta: ' + this.state.convoke_places_name + '\n';
						}
						
						if(this.state.extraction_type_id !== "all" && this.state.extraction_type_id !== ""){
							filterInfo += 'Extracción: ' + this.state.extraction_type_name + '\n';
						}
						
						if(this.state.donation_type_id !== "all" && this.state.donation_type_id !== ""){
							filterInfo += 'Donación: ' + this.state.donation_type_name + '\n';
						}
						
						// Agregar totales al final
						var totalsInfo = '\n\nTotales:\n';
						totalsInfo += 'Total de Muestras: ' + this.state.count + '\n';
						totalsInfo += 'Total de Fenotipos: ' + this.state.phenotypes_total + '\n';
						totalsInfo += 'Aptos: ' + (this.state.total_aptos != undefined ? this.state.total_aptos : 0) + '\n';
						totalsInfo += 'No Aptos: ' + (this.state.total_noAptos != undefined ? this.state.total_noAptos : 0);
						
						// Encontrar la última fila con datos y agregar la información
						var lastRow = $('row', sheet).length;
						var newRowIndex = lastRow + 3;
						
						// Crear las filas con la información de totales
						var totalRows = totalsInfo.split('\n');
						totalRows.forEach((row, index) => {
							if(row.trim() !== ''){
								$('sheetData', sheet).append('<row r="' + (newRowIndex + index) + '"><c r="A' + (newRowIndex + index) + '" t="inlineStr"><is><t>' + row + '</t></is></c></row>');
							}
						});
					}
            	},
            	{
                	extend: 'pdf',
					title: this.state.filename,
					orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

						if(this.state.search_type === 'date'){
							doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });

							doc.content.splice(3, 0, {
								columns:[
									this.state.convoke_places_id !== "all" ?
										{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
									: {text:"", width:0},
									this.state.convoke_places_id !== "all" ?
										{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
									: {text:"", width:0},

									this.state.extraction_type_id !== "all" ?
										{text: 'Extracción', width:'8%', fontSize:6.5}
									: {text:"", width:0},
									this.state.extraction_type_id !== "all" ?
										{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
									: {text:"", width:0},

									this.state.donation_type_id !== "all" ?
										{text: 'Donación', width:'8%', fontSize:6.5}
									: {text:"", width:0},
									this.state.donation_type_id !== "all" ?
										{text: this.state.donation_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
									: {text:"", width:0},

									this.state.group_name !== "" || this.state.rh_name !== "" ?
										{text: 'Grupo & RH', width:'8%', fontSize:6.5}
									: {text:"", width:0},
									this.state.group_name !== "" || this.state.rh_name !== "" ?
										{text: (this.state.group_name+' '+this.state.rh_name), bold:1, margin:[0,0,0,10], fontSize:6.5}
									: {text:"", width:0}

								]
							});
							
							doc.content[4].table.body.map((b, i)=>{
	                			b.map((t, j)=>{
	                				if(j > 1){
	                					b[j].alignment = 'center' 
	                				}         				
	                			})
	                		});
						}else{
							doc.content.splice(2, 0, {
								columns:[
									this.state.convoke_places_id !== "all" ?
										{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
									: {text:"", width:0},
									this.state.convoke_places_id !== "all" ?
										{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
									: {text:"", width:0},

									this.state.extraction_type_id !== "all" ?
										{text: 'Extracción', width:'8%', fontSize:6.5}
									: {text:"", width:0},
									this.state.extraction_type_id !== "all" ?
										{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
									: {text:"", width:0},

									this.state.donation_type_id !== "all" ?
										{text: 'Donación', width:'8%', fontSize:6.5}
									: {text:"", width:0},
									this.state.donation_type_id !== "all" ?
										{text: this.state.donation_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
									: {text:"", width:0}

								]
							});
							doc.content[3].table.body.map((b, i)=>{
	                			b.map((t, j)=>{
	                				if(j > 1){
	                					b[j].alignment = 'center' 
	                				}         				
	                			})
	                		});
						}

						doc.content[5] = {
							text:'Total de Muestras: '+this.state.count,
							margin:[5,15,0,0]
						}
						doc.content[6] = {
							text:'Total de Fenotipos: '+this.state.phenotypes_total,
							margin:[5,5,0,0]
            			}
						//Aptos y no aptos
						doc.content[7] = {
							text:'Aptos: '+(this.state.total_aptos != undefined ? this.state.total_aptos : 0),
							margin:[5,5,0,0]
            			}
						doc.content[8] = {
							text:'No Aptos: '+(this.state.total_noAptos != undefined ? this.state.total_noAptos : 0),
							margin:[5,5,0,0]
            			}
            			//doc.content[2].table.widths=["35%","15%","10%","10%","15%","15%"];
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 

                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            	],
			data: this.state.listado,
			columns:this.state.columns,
			order: [[ 2, "asc" ]],
			columnDefs: [{
		        targets: targets,
		        className: 'dt-center'
    		}],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false

		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'lab_sections_id'){
			var options = e.target.options;
			var value = [];
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push(options[i].value);
			    		break;
			    	}else{
			    		value.push(parseInt(options[i].value));
			    	}
			      
			    }
			}

			this.setState({
				[e.target.name]: value
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}

			

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				//this.getLabSection();
			}, 500);
				
		}else if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text,
				show_options:false,
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text,
				show_options:false,
			})
		}else if(e.target.name === 'donation_type_id'){
			this.setState({
				donation_type_name: e.target.options[e.target.selectedIndex].text,
				show_options:false,
			})
		}else if(e.target.name === 'group'){
			this.setState({
				group_name: e.target.options[e.target.selectedIndex].text,
				show_options:false,
			})
		}else if(e.target.name === 'rh'){
			this.setState({
				rh_name: e.target.options[e.target.selectedIndex].text,
				show_options:false,
			})
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				
				
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					extraction_type_id: this.state.extraction_type_id,
					work_sessions_id: this.state.work_sessions_id,
					donation_type_id: this.state.donation_type_id,
					group: this.state.group,
					rh: this.state.rh,
					health_facilities_id:this.state.health_facilities_id,
					option:this.state.option
				}
				
				fetch(Config.default.apiGateway.URL+'reports/blood_groups',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var cols = [
							{title:'Donador', width:'200px', visible:'block'},
							{title:'Fecha de Nacimiento', width:'100px', visible:'block'},							
							{title:'No. Donador', width:'120px', visible:'block'},
							{title:'Apto', width:'80px', visible:'block'},
							{title:'Fecha Extracción', width:'200px', visible:'block'},
							{title:'No. Donación', width:'150px', visible:'block'},
							{title:'Sexo', width:'100px', visible:'block'},
							{title:'Tipo Donación', width:'150px', visible:'block'},
							{title:'Tipo Extracción', width:'150px', visible:'block'},
							{title:'Grupo Inicial', width:'150px', visible:'block'},	
						];

						response.dynamic_columns.map((d)=>{
							cols.push({title:d.code, visible:'block', width:'90px'});
						});
						cols.push(
							{title:'Fenotipos', width:'200px', visible:'block'},
							{title:'Anticuerpos', width:'200px', visible:'block'},
							{title:'Usuario', width:'200px', visible:'block'},
						);
						this.setState({
							columns: cols
						});

						this.setState({
							total_aptos: response.total_aptos,
							total_noAptos: response.total_noAptos,
						});
						var list = [];
						response.res.map((r)=>{
							var obj = [
								r.donor_name,
								moment(r.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY'),
								r.donor_number,
								r.validation,
								r.timestamp_date !== null ?
									moment(r.timestamp_date).format('DD/MM/YYYY')+' '+
									(r.timestamp_hour !== null ?
										moment(r.timestamp_hour, 'HH:mm:ss').format('HH:mm')
									: null)
								: null,
								r.donation_number,
								r.sex,
								r.donation_type,
								r.extraction_type,
								r.init_g_rh,
							];
														

							response.dynamic_columns.map((col, i)=>{
								if(r.results !== null){
									var index = r.results.findIndex(obj => obj.analitical_test_id === col.id);

									if(index !== -1){
										obj.push(r.results[index].test_result === 'POSITIVO' ?
														'POS'
													: r.results[index].test_result === 'NEGATIVO' ?
														'NEG'
													: r.results[index].test_result)
									}else{
										obj.push('');
									}
								}else{
									obj.push('');
								}
							})

							obj.push(r.phenotypes, r.antibodies, r.user);

							list.push(obj);
						});

						console.log(cols, list)
						this.setState({
							listado: list,
							columns:cols,
							count: response.Count,
							phenotypes_total:response.total_phenotypes,
							show_options:true
						});

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getDonationsType(){
 		fetch(Config.default.apiGateway.URL+'donation_type/actives', {
 			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
 		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					donations_type: response
				});
			}
		});
 	}

	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{t('sidebar.nav.reports.blood_groups')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_inmuno_report"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>
								
								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}
									
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.id}>
												{don.donation_type_process}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Donación</span>
									<select className="form-control"  name="donation_type_id" id="donation_type_id"
										value={this.state.donation_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.donations_type.map((d, i)=>{
											return <option key={i} value={d.donation_type.id}>
												{d.lookup_value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Turno</span>
									<select className="form-control" name="work_sessions_id" id="work_sessions_id" 
										value={this.state.work_sessions_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="-1">TODOS</option>
										{this.state.work_sessions.map((w, i)=>{
											return <option key={i} value={w.id}>
												{w.value}
											</option>
										})}
									</select>
								</div>		

								<div className="form-group">
									<span className="span-min">Opción</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all_offers">TODOS</option>
										<option value="ACCEPT">APTO</option>
										<option value="NO">NO APTO</option>
									</select>
								</div>

								<div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Grupo</span>
										<select className="form-control"  name="group" id="group"
											value={this.state.group} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.rhGroup.map(function(t,index) {
								                return index % 2 === 0 ? 
								                	<option key={index}  value={t.key_group} >
								                  		{t.key_group} 
								                	</option>
								                :null
								            })}
										</select>
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">RH</span>
										<select className="form-control"  name="rh" id="rh"
											value={this.state.rh} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											<option value="POSITIVO">POSITIVO</option>
											<option value="NEGATIVO">NEGATIVO</option>
										</select>
									</div>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											Reporte Inmunohematologia
										</span>
									</div>
								</div>
								{this.state.search_type === 'date' ?
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:   {this.state.start_date !== "" ? 
												moment(this.state.start_date).format('DD/MM/YYYY')
											:'  '}
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ? 
												moment(this.state.end_date).format('DD/MM/YYYY')
											:'  '}
										</span>
									</div>
								: null}

								{this.state.show_options ? 
									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== "" ?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id!== ""?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>	
										:null}

										{this.state.donation_type_id !== 'all' && this.state.donation_type_id !== "" ?
											<span style={{marginLeft:"15px"}}>
												Donacion:  
												<b style={{marginLeft:"5px"}}>{this.state.donation_type_name}</b>
											</span>	
										:null}

										{this.state.group_name  !== "" && this.state.rh_name !== ""?
											<span style={{marginLeft:"15px"}}>
												Grupo & RH: 
												<b style={{marginLeft:"5px"}}>
													{this.state.group_name+' '+this.state.rh_name}
												</b>
											</span>
										:null}
									</div>
								:null}

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>

								<div className="col-xs-12" style={{fontSize:"14px"}}>
									<label style={{margin:"0 5px"}}>Total de Muestras:</label>{' '+this.state.count}
								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<label style={{margin:"0 5px"}}>Total de Fenotipos:</label>{' '+this.state.phenotypes_total}
								</div>

								{/* TOTAL APTOS O NO APTOS */}
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<label style={{margin:"0 5px"}}>Aptos: {this.state.total_aptos != undefined ? ' '+this.state.total_aptos : 0 }</label>
								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<label style={{margin:"0 5px"}}>No Aptos: {this.state.total_noAptos != undefined ? ' '+this.state.total_noAptos : 0 }</label>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (BloodGroups);